/**
 COOKIE Settings Window
 Version 1.0
 * */

import Cookies from 'js-cookie';

export default function cookiesSettings(bootstrap) {
  const cookiesModal = document.querySelector('#cookiesSettingsModal');

  if (!cookiesModal || !bootstrap) {
    return;
  }

  const cookiesModalInstance = bootstrap.Modal.getOrCreateInstance(cookiesModal);
  const cookiesRequiredBtn = cookiesModal.querySelector('#cookiesRequiredBtn');
  const cookiesAllBtn = cookiesModal.querySelector('#cookiesAllBtn');
  const cookiesSettingsBtn = cookiesModal.querySelector('#cookiesSettingsBtn');
  // const cookiesRequiredSwitch = cookiesModal.querySelector('#cookiesRequiredSwitch')
  const cookiesCustomSwitch = cookiesModal.querySelector('#cookiesCustomSwitch');
  const cookiesStatsSwitch = cookiesModal.querySelector('#cookiesStatsSwitch');
  const cookiesMarketingSwitch = cookiesModal.querySelector('#cookiesMarketingSwitch');
  const value = 'granted';

  function updateConsentMode() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'consent_update',
    });
    if (document.documentElement.dataset.ga4CaptureEnabled === '1'
      && (Cookies.get('_cookieSettingsStats') !== 'granted' || Cookies.get('_cookieSettingsMarketing') !== 'granted')) {
      // Restriction only. This never grants server-side analytics consent.
      fetch('/order/restrictGa4Consent', { method: 'POST', credentials: 'same-origin', keepalive: true }).catch(() => {});
    }
  }

  function setRequired() {
    Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
    Cookies.remove('_cookieSettingsCustom');
    Cookies.remove('_cookieSettingsMarketing');
    Cookies.remove('_cookieSettingsStats');
    cookiesCustomSwitch.checked = false;
    cookiesStatsSwitch.checked = false;
    cookiesMarketingSwitch.checked = false;
    updateConsentMode();
    cookiesModalInstance.hide();
  }

  function setAll() {
    Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
    Cookies.set('_cookieSettingsCustom', value, { expires: 365 });
    Cookies.set('_cookieSettingsMarketing', value, { expires: 365 });
    Cookies.set('_cookieSettingsStats', value, { expires: 365 });
    cookiesCustomSwitch.checked = true;
    cookiesStatsSwitch.checked = true;
    cookiesMarketingSwitch.checked = true;
    updateConsentMode();
    cookiesModalInstance.hide();
  }

  function setSettings() {
    Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
    updateConsentMode();
    cookiesModalInstance.hide();
  }

  function setCustom(set) {
    if (set) {
      Cookies.set('_cookieSettingsCustom', value, { expires: 365 });
    } else {
      Cookies.remove('_cookieSettingsCustom');
    }
  }

  function setStats(set) {
    if (set) {
      Cookies.set('_cookieSettingsStats', value, { expires: 365 });
    } else {
      Cookies.remove('_cookieSettingsStats');
    }
  }

  function setMarketing(set) {
    if (set) {
      Cookies.set('_cookieSettingsMarketing', value, { expires: 365 });
    } else {
      Cookies.remove('_cookieSettingsMarketing');
    }
  }

  cookiesRequiredBtn.addEventListener('click', setRequired);
  cookiesAllBtn.addEventListener('click', setAll);
  cookiesSettingsBtn.addEventListener('click', setSettings);
  cookiesCustomSwitch.addEventListener('change', (e) => setCustom(e.target.checked));
  cookiesStatsSwitch.addEventListener('change', (e) => setStats(e.target.checked));
  cookiesMarketingSwitch.addEventListener('change', (e) => setMarketing(e.target.checked));

  Cookies.get('_cookieSettingsRequired') === '1' && Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
  Cookies.get('_cookieSettingsCustom') === '1' && Cookies.set('_cookieSettingsCustom', value, { expires: 365 });
  Cookies.get('_cookieSettingsStats') === '1' && Cookies.set('_cookieSettingsStats', value, { expires: 365 });
  Cookies.get('_cookieSettingsMarketing') === '1' && Cookies.set('_cookieSettingsMarketing', value, { expires: 365 });

  updateConsentMode();

  if (!Cookies.get('_cookieSettingsRequired')) {
    cookiesModalInstance.show();
  }
}
